import { httpClient } from "../../../../services/httpClient";

/**
 * Obtiene el dashboard de cajero con filtros opcionales.
 * Params soportados: centro_id, curso_id, promocion_id, startDate, endDate.
 */
export const fetchCajeroDashboard = (params = {}) => {
  const searchParams = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      searchParams.append(key, value);
    }
  });

  const query = searchParams.toString();
  const path = `/api/dashboard/cajero${query ? `?${query}` : ""}`;
  return httpClient.get(path);
};

const dashboardCajeroService = {
  fetch: fetchCajeroDashboard,
};

export default dashboardCajeroService;
